import React from 'react'
import styled, { css } from 'styled-components'

import Table from 'components/Table'
import Tooltip from 'components/Tooltip'

import Resource, { ValidResourceTypes } from 'types/Resource'

import { screenSize } from 'styles/shared'
import { color } from 'styles/colors'

import PublishedCell from './PublishedCell'

type ResourceProps = {
  type: ValidResourceTypes
  resource: Resource
}

type Props = {
  resource: Resource
  type: ValidResourceTypes
  onSuccessfulSubmission: () => void
  onClickEditResource:(val:ResourceProps)=>void
}

const HelpResourceRow = ({ resource, type, onSuccessfulSubmission, onClickEditResource }: Props) => {
  if (resource == null) {
    return <></>
  }

  return (
    <S.TableRow key={resource.name}>
      <S.NameCell>
        <Tooltip title={'Click to view'} placement="top">
          <S.ThumbnailLink
            href={resource.url}
            target="_blank"
            rel="noreferrer"
          >
            <S.PictureAsPdfOutlined
              src={'/img/pdf_icon.svg'}
              alt={`${resource.name} help resource thumbnail`}
            />
            {resource.name}
          </S.ThumbnailLink>
        </Tooltip>
      </S.NameCell>

      <S.DescriptionCell>
        {resource.description}
      </S.DescriptionCell>

      <S.DateCell>
        {resource.createdAt}
      </S.DateCell>

      <S.PublishedCell type={type} resource={resource} onSuccessfulSubmission={onSuccessfulSubmission} onClickEditResource={onClickEditResource} />
    </S.TableRow>
  )
}
export default HelpResourceRow

const cellStyle = css`
  padding: 5px;
  min-width: 120px;

  @media ${screenSize.medium} {
    font-size: 12px;
  }
`

const S = {
  TableRow: styled(Table.Row)`
    align-items: center;
    margin: 10px;

    @media ${screenSize.small} {
      align-items: unset;
    }
  `,
  NameCell: styled(Table.Cell)`
    ${cellStyle}
    align-items: center;
    flex-basis: 25%;
  `,
  ThumbnailLink: styled.a`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: ${color('warrantyText')};
    font-weight: 500;
    text-decoration: none;

    &:hover {
      color: ${color('warrantyText')};
    }
  `,
  PictureAsPdfOutlined: styled.img`
    margin: 5px;

    @media ${screenSize.medium} {
      width: 30px;
      height: 30px;
    }
  `,
  DescriptionCell: styled(Table.Cell)`
    ${cellStyle}
    flex-basis: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding-left: 15px;
  `,
  DateCell: styled(Table.Cell)`
    ${cellStyle}
    flex-basis: 20%;
  `,

  PublishedCell: styled(PublishedCell)`
    ${cellStyle}
    flex-basis: 20%;
  `
}
